var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressFourGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 72,
    viewBox: "0 0 32 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31,
    rx: 15.5,
    fill: "#43BF5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2734 21V18.6562H11.6094V17.3828L16.5547 9.72656H18.6328V17.4219H20.2266V18.6562H18.6328V21H17.2734ZM13 17.4219H17.2734V10.9297H17.2266L13 17.3906V17.4219Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 72L16.5 31",
    stroke: "#43BF5E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressFourGreen);
export default __webpack_public_path__ + "static/media/progressFourGreen.4ee727838849e4d8783682ec805381b5.svg";
export { ForwardRef as ReactComponent };